/* eslint-disable react/require-default-props */

import React, { useState, useEffect, useContext } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;

import { extend, useDataModel, QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { ApplianceBundles } from '@thd-olt-component-react/appliance-bundles';
import { ThdRecsFbt } from '@thd-olt-component-react/thd-recs-fbt';
import { useConfigService, ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';

import { BundleMini } from './BundleMini';
import { useBundle } from '../hooks/useBundle';
import ZoneCard from '../subcomponents/zone-card';
import { ProductDataModel } from '../models/dataModel';
import { PackagesMiniAbTest } from '../subcomponents/PackagesMiniAbTest';
import { RENDER_TRANSACTIONAL, RENDER_VISUAL, RENDER_CO_WORK } from '../constants/index';
import { BundleMiniContextProvider } from '../context/BundleMiniContext';

const BundlePmvFbtLayoutMa = ({ itemId = '', showPackagesMini = true, name = '', noPipSpacing = false }) => {

  const storeId = useStoreId();
  const { data: productData } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId,
      storeId
    },
    skip: !itemId,
    ssr: false
  });

  const ctx = useContext(ExperienceContext);
  const { defaultVariables } = useContext(QueryContext);
  const [packagesMiniABTestType, setPackagesMiniABTestType] = useState('default');
  const applianceBundlesRedesignEnabled = useConfigService('fs:applianceBundlesRedesignEnabled') || false;
  const enableNewPartsServicesDrawer = useConfigService('enableNewPartsServicesDrawer') || false;
  const isB2BCustomer = ctx?.customer?.type === 'b2b';
  const { bundleIds } = useBundle({ product: productData?.product });
  const [isPackageEnabled, setIsPackageEnabled] = useState(showPackagesMini);

  useEffect(() => {
    [RENDER_TRANSACTIONAL, RENDER_VISUAL, RENDER_CO_WORK].forEach((type) => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on(`packages-mini.${type}`, (data) => {
        setPackagesMiniABTestType(data.output.enabled ? type : 'default');
      });
    });
  }, []);

  if (!productData) { return null; }

  if (bundleIds) {
    return (
      <BundleMiniContextProvider itemId={itemId}>
        <QueryProvider
          cacheKey="bundle-mini-provider"
          defaultVariables={defaultVariables.current}
        >
          <BundleMini bundleIds={bundleIds} name={name} noPipSpacing={noPipSpacing} />
        </QueryProvider>
      </BundleMiniContextProvider>
    );
  }

  if (isPackageEnabled) {
    return (
      <div data-testid={packagesMiniABTestType} className="sui-w-full">
        <PackagesMiniAbTest
          itemId={itemId}
          renderComponent={packagesMiniABTestType}
          callOnLoaded={({ didRender }) => {
            setIsPackageEnabled(didRender);
          }}
          noPipSpacing={noPipSpacing}
        />
      </div>
    );
  }

  return (
    <ZoneCard>
      {applianceBundlesRedesignEnabled && enableNewPartsServicesDrawer ? (
        <div data-testid="appliances-bundle">
          <ApplianceBundles itemId={itemId} isB2BCustomer={isB2BCustomer} />
        </div>
      ) : (
        <div data-testid="fbt">
          <ThdRecsFbt
            apiName="fbt_test"
            itemId={itemId}
            name={name}
            errorBoundary
            hydrator={{
              className: "grid",
              tag: ZoneCard,
              id: "thd-recs-fbt",
            }}
            noPipSpacing={noPipSpacing}
          />
        </div>
      )}
    </ZoneCard>
  );
};

BundlePmvFbtLayoutMa.propTypes = {
  itemId: string,
  showPackagesMini: bool,
  name: string,
  noPipSpacing: bool
};

BundlePmvFbtLayoutMa.dataModel = extend(
  ThdRecsFbt,
  ProductDataModel,
  PackagesMiniAbTest,
  podFulFillmentUtils
);

BundlePmvFbtLayoutMa.displayName = 'BundlePmvFbtLayoutMa';

export { BundlePmvFbtLayoutMa };